export interface Country {
  name: string;
  code: string;
  mask: string;
}

export const countryList: Country[] = [
  {
    name: 'Afghanistan',
    code: 'AF',
    mask: '99-999-9999',
  },
  {
    name: 'Aland Islands',
    code: 'AX',
    mask: '(999) 999-99-99',
  },
  {
    name: 'Albania',
    code: 'AL',
    mask: '(999) 999-999',
  },
  {
    name: 'Algeria',
    code: 'DZ',
    mask: '99-999-9999',
  },
  {
    name: 'American Samoa',
    code: 'AS',
    mask: '(684) 999-9999',
  },
  {
    name: 'Andorra',
    code: 'AD',
    mask: '999-999',
  },
  {
    name: 'Angola',
    code: 'AO',
    mask: '(999) 999-999',
  },
  {
    name: 'Anguilla',
    code: 'AI',
    mask: '(224) 999-9999',
  },
  {
    name: 'Antarctica',
    code: 'AQ',
    mask: '199-999',
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    mask: '(268) 999-9999',
  },
  {
    name: 'Argentina',
    code: 'AR',
    mask: '(999) 999-9999',
  },
  {
    name: 'Armenia',
    code: 'AM',
    mask: '99-999-999',
  },
  {
    name: 'Aruba',
    code: 'AW',
    mask: '999-9999',
  },
  {
    name: 'Ascension Island',
    code: 'AC',
    mask: '9999',
  },
  {
    name: 'Australia',
    code: 'AU',
    mask: '9-9999-9999',
  },
  {
    name: 'Austria',
    code: 'AT',
    mask: '(999) 999-9999',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    mask: '99-999-99-99',
  },
  {
    name: 'Bahamas',
    code: 'BS',
    mask: '(242) 999-9999',
  },
  {
    name: 'Bahrain',
    code: 'BH',
    mask: '9999-9999',
  },
  {
    name: 'Bangladesh',
    code: 'BD',
    mask: '99-999-999',
  },
  {
    name: 'Barbados',
    code: 'BB',
    mask: '(246) 999-9999',
  },
  {
    name: 'Belarus',
    code: 'BY',
    mask: '(99) 999-99-99',
  },
  {
    name: 'Belgium',
    code: 'BE',
    mask: '(999) 999-999',
  },
  {
    name: 'Belize',
    code: 'BZ',
    mask: '999-9999',
  },
  {
    name: 'Benin',
    code: 'BJ',
    mask: '99-99-9999',
  },
  {
    name: 'Bermuda',
    code: 'BM',
    mask: '(441) 999-9999',
  },
  {
    name: 'Bhutan',
    code: 'BT',
    mask: '9-999-999',
  },
  {
    name: 'Bolivia',
    code: 'BO',
    mask: '9-999-9999',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    mask: '99-99999',
  },
  {
    name: 'Botswana',
    code: 'BW',
    mask: '99-999-999',
  },
  {
    name: 'Brazil',
    code: 'BR',
    mask: '(99) 99999-9999',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    mask: '999-9999',
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
    mask: '999-9999',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    mask: '(999) 999-999',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    mask: '99-99-9999',
  },
  {
    name: 'Burundi',
    code: 'BI',
    mask: '99-99-9999',
  },
  {
    name: 'Cambodia',
    code: 'KH',
    mask: '99-999-999',
  },
  {
    name: 'Cameroon',
    code: 'CM',
    mask: '9999-9999',
  },
  {
    name: 'Canada',
    code: 'CA',
    mask: '(999) 999-9999',
  },
  {
    name: 'Cape Verde',
    code: 'CV',
    mask: '(999) 99-99',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    mask: '(345) 999-9999',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    mask: '99-99-9999',
  },
  {
    name: 'Chad',
    code: 'TD',
    mask: '99-99-99-99',
  },
  {
    name: 'Chile',
    code: 'CL',
    mask: '9-9999-9999',
  },
  {
    name: 'China',
    code: 'CN',
    mask: '99-99999-99999',
  },
  {
    name: 'Christmas Island',
    code: 'CX',
    mask: '9-9999-9999',
  },
  {
    name: 'Cocos (Keeling)  Islands',
    code: 'CC',
    mask: '9-9999-9999',
  },
  {
    name: 'Colombia',
    code: 'CO',
    mask: '(999) 999-9999',
  },
  {
    name: 'Comoros',
    code: 'KM',
    mask: '99-99999',
  },
  {
    name: 'Congo',
    code: 'CG',
    mask: '99-99999',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
    mask: '99-999',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    mask: '9999-9999',
  },
  {
    name: 'Croatia',
    code: 'HR',
    mask: '99-999-999',
  },
  {
    name: 'Cuba',
    code: 'CU',
    mask: '9-999-9999',
  },
  {
    name: 'Cyprus',
    code: 'CY',
    mask: '99-999-999',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    mask: '(999) 999-999',
  },
  {
    name: 'Democratic Republic of the Congo',
    code: 'CD',
    mask: '(999) 999-999',
  },
  {
    name: 'Denmark',
    code: 'DK',
    mask: '99-99-99-99',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
    mask: '99-99-99-99',
  },
  {
    name: 'Dominica',
    code: 'DM',
    mask: '(767) 999-9999',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
    mask: '(999) 999-9999',
  },
  {
    name: 'Ecuador',
    code: 'EC',
    mask: '99-999-9999',
  },
  {
    name: 'Egypt',
    code: 'EG',
    mask: '(999) 999-9999',
  },
  {
    name: 'El Salvador',
    code: 'SV',
    mask: '99-99-9999',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    mask: '99-999-9999',
  },
  {
    name: 'Eritrea',
    code: 'ER',
    mask: '9-999-999',
  },
  {
    name: 'Estonia',
    code: 'EE',
    mask: '9999-9999',
  },
  {
    name: 'Eswatini',
    code: 'SZ',
    mask: '99-99-9999',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
    mask: '99-999-9999',
  },
  {
    name: 'Falkland Islands (Malvinas) ',
    code: 'FK',
    mask: '99999',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    mask: '999-999',
  },
  {
    name: 'Fiji',
    code: 'FJ',
    mask: '99-99999',
  },
  {
    name: 'Finland',
    code: 'FI',
    mask: '(999) 999-99-99',
  },
  {
    name: 'France',
    code: 'FR',
    mask: '(999) 999-999',
  },
  {
    name: 'French Guiana',
    code: 'GF',
    mask: '99999-9999',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
    mask: '99-99-99',
  },
  {
    name: 'Gabon',
    code: 'GA',
    mask: '9-99-99-99',
  },
  {
    name: 'Gambia',
    code: 'GM',
    mask: '(999) 99-99',
  },
  {
    name: 'Georgia',
    code: 'GE',
    mask: '(999) 999-999',
  },
  {
    name: 'Germany',
    code: 'DE',
    mask: '(9999) 999-9999',
  },
  {
    name: 'Ghana',
    code: 'GH',
    mask: '(999) 999-999',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    mask: '999-99999',
  },
  {
    name: 'Greece',
    code: 'GR',
    mask: '(999) 999-9999',
  },
  {
    name: 'Greenland',
    code: 'GL',
    mask: '99-99-99',
  },
  {
    name: 'Grenada',
    code: 'GD',
    mask: '(473) 999-9999',
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
    mask: '(999) 999-999',
  },
  {
    name: 'Guam',
    code: 'GU',
    mask: '(671) 999-9999',
  },
  {
    name: 'Guatemala',
    code: 'GT',
    mask: '9-999-9999',
  },
  {
    name: 'Guernsey',
    code: 'GG',
    mask: '99-9999-9999',
  },
  {
    name: 'Guinea',
    code: 'GN',
    mask: '99-999-999',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
    mask: '9-999999',
  },
  {
    name: 'Guyana',
    code: 'GY',
    mask: '999-9999',
  },
  {
    name: 'Haiti',
    code: 'HT',
    mask: '99-99-9999',
  },
  {
    name: 'Holy See (Vatican City State) ',
    code: 'VA',
    mask: '06 69899999',
  },
  {
    name: 'Honduras',
    code: 'HN',
    mask: '9999-9999',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    mask: '9999-9999',
  },
  {
    name: 'Hungary',
    code: 'HU',
    mask: '(999) 999-999',
  },
  {
    name: 'Iceland',
    code: 'IS',
    mask: '999-9999',
  },
  {
    name: 'India',
    code: 'IN',
    mask: '(9999) 999-999',
  },
  {
    name: 'Indonesia',
    code: 'ID',
    mask: '(999) 999-99-999',
  },
  {
    name: 'Iran',
    code: 'IR',
    mask: '(999) 999-9999',
  },
  {
    name: 'Iraq',
    code: 'IQ',
    mask: '(999) 999-9999',
  },
  {
    name: 'Ireland',
    code: 'IE',
    mask: '(999) 999-999',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
    mask: '99-9999-9999',
  },
  {
    name: 'Israel',
    code: 'IL',
    mask: '99-999-9999',
  },
  {
    name: 'Italy',
    code: 'IT',
    mask: '(999) 9999-999',
  },
  {
    name: "Ivory Coast / Cote d'Ivoire",
    code: 'CI',
    mask: '99-999-999',
  },
  {
    name: 'Jamaica',
    code: 'JM',
    mask: '(876) 999-9999',
  },
  {
    name: 'Japan',
    code: 'JP',
    mask: '(999) 999-999',
  },
  {
    name: 'Jersey',
    code: 'JE',
    mask: '99-9999-9999',
  },
  {
    name: 'Jordan',
    code: 'JO',
    mask: '9-9999-9999',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
    mask: '(999) 999-99-99',
  },
  {
    name: 'Kenya',
    code: 'KE',
    mask: '999-999999',
  },
  {
    name: 'Kiribati',
    code: 'KI',
    mask: '99-999',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    code: 'KP',
    mask: '9999-9999999999999',
  },
  {
    name: 'Korea, Republic of South Korea',
    code: 'KR',
    mask: '99-999-9999',
  },
  {
    name: 'Kosovo',
    code: 'XK',
    mask: '999-999-999',
  },
  {
    name: 'Kuwait',
    code: 'KW',
    mask: '9999-9999',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
    mask: '(999) 999-999',
  },
  {
    name: 'Laos',
    code: 'LA',
    mask: '(9999) 999-999',
  },
  {
    name: 'Latvia',
    code: 'LV',
    mask: '99-999-999',
  },
  {
    name: 'Lebanon',
    code: 'LB',
    mask: '99-999-999',
  },
  {
    name: 'Lesotho',
    code: 'LS',
    mask: '9-999-9999',
  },
  {
    name: 'Liberia',
    code: 'LR',
    mask: '99-999-999',
  },
  {
    name: 'Libya',
    code: 'LY',
    mask: '99-999-9999',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
    mask: '(999) 999-9999',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    mask: '(999) 99-999',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    mask: '(999) 999-999',
  },
  {
    name: 'Macau',
    code: 'MO',
    mask: '9999-9999',
  },
  {
    name: 'Madagascar',
    code: 'MG',
    mask: '99-99-99999',
  },
  {
    name: 'Malawi',
    code: 'MW',
    mask: '9-9999-9999',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    mask: '(999) 999-999',
  },
  {
    name: 'Maldives',
    code: 'MV',
    mask: '999-9999',
  },
  {
    name: 'Mali',
    code: 'ML',
    mask: '99-99-9999',
  },
  {
    name: 'Malta',
    code: 'MT',
    mask: '9999-9999',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
    mask: '999-9999',
  },
  {
    name: 'Martinique',
    code: 'MQ',
    mask: '(999) 99-99-99',
  },
  {
    name: 'Mauritania',
    code: 'MR',
    mask: '99-99-9999',
  },
  {
    name: 'Mauritius',
    code: 'MU',
    mask: '999-9999',
  },
  {
    name: 'Mayotte',
    code: 'YT',
    mask: '99999-9999',
  },
  {
    name: 'Mexico',
    code: 'MX',
    mask: '(999) 999-9999',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    code: 'FM',
    mask: '999-9999',
  },
  {
    name: 'Moldova',
    code: 'MD',
    mask: '9999-9999',
  },
  {
    name: 'Monaco',
    code: 'MC',
    mask: '(999) 999-999',
  },
  {
    name: 'Mongolia',
    code: 'MN',
    mask: '99-99-9999',
  },
  {
    name: 'Montenegro',
    code: 'ME',
    mask: '99-999-999',
  },
  {
    name: 'Montserrat',
    code: 'MS',
    mask: '(624) 999-9999',
  },
  {
    name: 'Morocco',
    code: 'MA',
    mask: '99-9999-999',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
    mask: '99-999-999',
  },
  {
    name: 'Myanmar',
    code: 'MM',
    mask: '99-999-999',
  },
  {
    name: 'Namibia',
    code: 'NA',
    mask: '99-999-9999',
  },
  {
    name: 'Nauru',
    code: 'NR',
    mask: '999-9999',
  },
  {
    name: 'Nepal',
    code: 'NP',
    mask: '99-999-999',
  },
  {
    name: 'Netherlands',
    code: 'NL',
    mask: '99-999-9999',
  },
  {
    name: 'Netherlands Antilles',
    code: 'AN',
    mask: '9999-9999',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
    mask: '99-9999',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    mask: '(999) 999-9999',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    mask: '9999-9999',
  },
  {
    name: 'Niger',
    code: 'NE',
    mask: '99-99-9999',
  },
  {
    name: 'Nigeria',
    code: 'NG',
    mask: '(999) 999-9999',
  },
  {
    name: 'Niue',
    code: 'NU',
    mask: '9999',
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
    mask: '399-999',
  },
  {
    name: 'North Macedonia',
    code: 'MK',
    mask: '99-999-999',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    mask: '(670) 999-9999',
  },
  {
    name: 'Norway',
    code: 'NO',
    mask: '(999) 99-999',
  },
  {
    name: 'Oman',
    code: 'OM',
    mask: '99-999-999',
  },
  {
    name: 'Pakistan',
    code: 'PK',
    mask: '(999) 999-9999',
  },
  {
    name: 'Palau',
    code: 'PW',
    mask: '999-9999',
  },
  {
    name: 'Palestine',
    code: 'PS',
    mask: '99-999-9999',
  },
  {
    name: 'Panama',
    code: 'PA',
    mask: '999-9999',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    mask: '(999) 99-999',
  },
  {
    name: 'Paraguay',
    code: 'PY',
    mask: '(999) 999-999',
  },
  {
    name: 'Peru',
    code: 'PE',
    mask: '(999) 999-999',
  },
  {
    name: 'Philippines',
    code: 'PH',
    mask: '(999) 999-9999',
  },
  {
    name: 'Pitcairn',
    code: 'PN',
    mask: '999-999-999',
  },
  {
    name: 'Poland',
    code: 'PL',
    mask: '(999) 999-999',
  },
  {
    name: 'Portugal',
    code: 'PT',
    mask: '99-999-9999',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    mask: '(999)  999 9999',
  },
  {
    name: 'Qatar',
    code: 'QA',
    mask: '9999-9999',
  },
  {
    name: 'Reunion',
    code: 'RE',
    mask: '99999-9999',
  },
  {
    name: 'Romania',
    code: 'RO',
    mask: '99-999-9999',
  },
  {
    name: 'Russia',
    code: 'RU',
    mask: '(999) 999-99-99',
  },
  {
    name: 'Rwanda',
    code: 'RW',
    mask: '(999) 999-999',
  },
  {
    name: 'Saint Barthelemy',
    code: 'BL',
    mask: '999-99-99-99',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    code: 'SH',
    mask: '9999',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    mask: '(869) 999-9999',
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
    mask: '(758) 999-9999',
  },
  {
    name: 'Saint Martin',
    code: 'MF',
    mask: '(999) 999-999',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    mask: '99-9999',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    mask: '(784) 999-9999',
  },
  {
    name: 'Samoa',
    code: 'WS',
    mask: '99-9999',
  },
  {
    name: 'San Marino',
    code: 'SM',
    mask: '9999-999999',
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
    mask: '99-99999',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    mask: '99-9999-9999',
  },
  {
    name: 'Senegal',
    code: 'SN',
    mask: '99-999-9999',
  },
  {
    name: 'Serbia',
    code: 'RS',
    mask: '99-999-9999',
  },
  {
    name: 'Seychelles',
    code: 'SC',
    mask: '9-999-999',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
    mask: '99-999999',
  },
  {
    name: 'Singapore',
    code: 'SG',
    mask: '9999-9999',
  },
  {
    name: 'Sint Maarten',
    code: 'SX',
    mask: '(721) 999-9999',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    mask: '(999) 999-999',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    mask: '99-999-999',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
    mask: '999-9999',
  },
  {
    name: 'Somalia',
    code: 'SO',
    mask: '99-999-999',
  },
  {
    name: 'South Africa',
    code: 'ZA',
    mask: '99-999-9999',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    mask: '99999',
  },
  {
    name: 'South Sudan',
    code: 'SS',
    mask: '99-999-9999',
  },
  {
    name: 'Spain',
    code: 'ES',
    mask: '(999) 999-999',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
    mask: '99-999-9999',
  },
  {
    name: 'Sudan',
    code: 'SD',
    mask: '99-999-9999',
  },
  {
    name: 'Suriname',
    code: 'SR',
    mask: '999-9999',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    mask: '(999) 99-999',
  },
  {
    name: 'Sweden',
    code: 'SE',
    mask: '99-999-9999',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    mask: '99-999-9999',
  },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
    mask: '99-9999-999',
  },
  {
    name: 'Taiwan',
    code: 'TW',
    mask: '9-9999-9999',
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
    mask: '99-999-9999',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    code: 'TZ',
    mask: '99-999-9999',
  },
  {
    name: 'Thailand',
    code: 'TH',
    mask: '99-999-9999',
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
    mask: '999-99999',
  },
  {
    name: 'Togo',
    code: 'TG',
    mask: '99-999-999',
  },
  {
    name: 'Tokelau',
    code: 'TK',
    mask: '9999',
  },
  {
    name: 'Tonga',
    code: 'TO',
    mask: '99999',
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    mask: '(868) 999-9999',
  },
  {
    name: 'Tunisia',
    code: 'TN',
    mask: '99-999-999',
  },
  {
    name: 'Turkey',
    code: 'TR',
    mask: '(999) 999-9999',
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
    mask: '9-999-9999',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    mask: '(249) 999-999',
  },
  {
    name: 'Tuvalu',
    code: 'TV',
    mask: '909999',
  },
  {
    name: 'Uganda',
    code: 'UG',
    mask: '(999) 999-999',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    mask: '(99) 999-99-99',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    mask: '99-999-9999',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    mask: '99-9999-9999',
  },
  {
    name: 'United States',
    code: 'US',
    mask: '(999) 999-9999',
  },
  {
    name: 'Uruguay',
    code: 'UY',
    mask: '9-999-99-99',
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
    mask: '99-999-9999',
  },
  {
    name: 'Vanuatu',
    code: 'VU',
    mask: '99-99999',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    code: 'VE',
    mask: '(999) 999-9999',
  },
  {
    name: 'Vietnam',
    code: 'VN',
    mask: '(999) 9999-999',
  },
  {
    name: 'Virgin Islands, British',
    code: 'VG',
    mask: '(284) 999-9999',
  },
  {
    name: 'Virgin Islands, U.S.',
    code: 'VI',
    mask: '(340) 999-9999',
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    mask: '99-9999',
  },
  {
    name: 'Yemen',
    code: 'YE',
    mask: '999-999-999',
  },
  {
    name: 'Zambia',
    code: 'ZM',
    mask: '99-999-9999',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    mask: '9-999999',
  },
];
